import {isCommunity, isEvent} from 'common-data-handling';
import React from 'react';
import TopBar from '../../../elements/TopBar/TopBar';
import {useI18n} from '../../../../data/hooks/i18nHooks';

/**
 * TopBar for the AddEventWithCode screen
 * Show different titles for communities and events
 *
 * @param {object} props - The properties object containing the event data.
 * @param {object} props.event - The event object.
 * @returns
 */
function AddEventWithCodeTopBar(props) {
    const {event} = props,
        i18n = useI18n();

    let title = '';
    if (event) {
        if (isCommunity(event)) {
            title = i18n['label.join-community-title'];
        } else if (isEvent(event)) {
            title = i18n['label.join-event-title'];
        }
    }

    return <TopBar returnURL="/">{title}</TopBar>;
}

export default AddEventWithCodeTopBar;
